// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"assets_i18n_en_translation_json":"f86c189bba7b4e9951ef","assets_i18n_nl_translation_json":"0569510c216b0e42ced9"}[chunkId] + ".chunk.js";
};